module.exports = __webpack_public_path__ + "img/como-funciona-o-pedale.2fe569c8.jpg";